// forensicsController
(function () {

    'use strict';
    angular.module('app')
        .controller('forensicsController',
            [
                '$sce', '$location', '$routeParams', 'thirdPartyService', '_',
                forensicsController
            ]
        );

    function forensicsController($sce, $location, $routeParams, thirdPartyService, _) {
        var vm = this;

        vm.baseUrl = 'https://www.sendforensics.com/partners/communigator/processing?';

        // uid=lz&linkid=2096

        vm.token = $routeParams.t;
        vm.uid = $routeParams.uid;
        vm.linkId = $routeParams.linkid;

        if (!_.isUndefined(vm.token)) {
            thirdPartyService.getForensicsParams(vm.token).then(function(response) {
                vm.url = $sce.trustAsResourceUrl(vm.baseUrl + response);
            });
        } else {
            // need to get the actual link
            thirdPartyService.getForensicsToken(vm.linkId).then(function(response) {
                //vm.url = $sce.trustAsResourceUrl(vm.baseUrl + response);
                var path = '/thirdparty/forensics?t=' + response;
                $location.url(path).replace();
            });
        }

    }
})();